import {} from "@next-platform/packages-ts-types";
const RANDOM_ID_BASE = 36;
const RANDOM_ID_SUFFIX_LENGTH = 12;
function defaultGenerateAnonymousId() {
    if (typeof globalThis.crypto !== "undefined" &&
        typeof globalThis.crypto.randomUUID === "function") {
        return globalThis.crypto.randomUUID();
    }
    const random = Math.random()
        .toString(RANDOM_ID_BASE)
        .slice(2, 2 + RANDOM_ID_SUFFIX_LENGTH);
    return `anon-${Date.now().toString(RANDOM_ID_BASE)}-${random}`;
}
const defaultHost = {
    generateAnonymousId: defaultGenerateAnonymousId,
    now: () => Date.now(),
};
let host = defaultHost;
/**
 * Overrides one or more fields of the default attribution host. Subsequent
 * calls merge over the existing host, so a consumer can install a signer
 * early and an anonymous-id factory later.
 */
export function configureAttribution(overrides) {
    host = { ...host, ...overrides };
}
/**
 * Returns the live attribution host for use by the shim's internal
 * capture/handoff helpers. Exported for tests; application code should
 * use the higher-level entry points.
 */
export function getAttributionHost() {
    return host;
}
/**
 * Resets the host to its default state. Intended for tests.
 */
export function resetAttributionHostForTests() {
    host = defaultHost;
}
